import React, { useState, useEffect } from "react";
import MenuItem from '@mui/material/MenuItem';
import ThemeButton from '../buttons/ThemeButton'
import { useLazyQuery, useMutation } from '@apollo/client';
import { ALL_THEMES_QUERY } from '../../graph/SiteGraph';
import { USER_PREFERENCES_QUERY, UPDATE_THEME_MUTATION } from '../../graph/UserGraph';
import Skeleton from '@mui/material/Skeleton';

export default function ThemeMenuItem({ setTheme, isDark }) {
    const [updatePreferences] = useMutation(UPDATE_THEME_MUTATION);
    const [getLazyAllThemes, lazyAllThemesResults] = useLazyQuery(ALL_THEMES_QUERY, {
        fetchPolicy: 'cache-first',
    });
    const [getLazyPreferences, lazyPreferencesResults] = useLazyQuery(USER_PREFERENCES_QUERY, {
        fetchPolicy: 'cache-first',
    });

    useEffect(() => {
        getLazyAllThemes()
        getLazyPreferences()
    }, [])


    const errors = lazyAllThemesResults.error || lazyPreferencesResults.error;
    const loading = lazyAllThemesResults.loading || lazyPreferencesResults.loading;

    if (loading) return <Skeleton variant={"rectangular"} height={"1.6em"} />;
    if (errors) return (`Error! ${errors}`)

    let allThemesData = lazyAllThemesResults.data?.themeList
    let currentTheme = lazyPreferencesResults.data?.preferences.theme.name || localStorage.getItem("appTheme")

    const onClick = () => {
        const new_theme = allThemesData.filter((theme) => theme.name.toLowerCase() != currentTheme.toLowerCase())
        const new_theme_id = new_theme[0].id
        console.log("new theme id", currentTheme, new_theme, new_theme_id, lazyPreferencesResults.data.preferences.id)
        updatePreferences({
            variables: { id: lazyPreferencesResults.data.preferences.id, theme_id: new_theme_id, userId: localStorage.getItem("userID") }
        });
        setTheme((new_theme[0].name).toLowerCase())
        localStorage.setItem("appTheme", (new_theme[0].name).toLowerCase())
    };

    return (
        <MenuItem onClick={onClick}>
            <ThemeButton />
        </MenuItem>
    );
}
